// HomePage.js
import React, { useRef, useEffect } from "react";
import CustomCarousel from "../components/Home/CustomCarousel.js";
import QuickAccessServices from "../components/Home/QuickAccessServices.js";
import InfoBanner from "../components/Home/InfoBanner.js";
import Section from "../components/Home/Section.js";
import PharmacyInfo from "../components/Home/PharmacyInfo.js";
import Footer from "../components/Footer.js";
import VaccinationSection from "../components/Home/VaccinationSection.js";
import PrescribingPharmacist from "../components/Home/PrescribingPharmacist.js";
import SplitInfoSection from "../components/Home/SplitInfoSection.js";
import DeliveryBanner from "../components/Home/DeliveryBanner.js";
import Testimonials from "../components/Home/Testionials.js";
import { useLocation } from "react-router-dom";
import useWindowDimensions from "../hooks/useWindowDimensions.js";
function Home() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const { width, height } = useWindowDimensions();

  const quickAccessRef = useRef(null);
  const vaccinationRef = useRef(null);

  const scrollToQuickAccess = () => {
    if (quickAccessRef.current) {
      quickAccessRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <CustomCarousel scrollToQuickAccess={scrollToQuickAccess} />
      {/* Pass the scroll function to InfoBanner */}
      <InfoBanner />
      <div ref={quickAccessRef}>
        <QuickAccessServices />
      </div>
      <SplitInfoSection />
      {width > 1120 && <PrescribingPharmacist />}
      {/* Attach the ref to VaccinationSection */}

      <div className="w-[100%] h-[25px] bg-white"></div>
      <div ref={vaccinationRef}>
        <VaccinationSection />
      </div>
      {/* <DeliveryBanner /> */}
      <Testimonials />
    </div>
  );
}

export default Home;
